/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * Temporary demo page to preview all CoreXLoader animation variants.
 * Remove after review.
 */
import { useState } from 'react';
import { CoreXLoader } from '@/components/ui/CoreXLoader';

type Anim = 'orbiting-rings' | 'hex-grid' | 'scan-reveal' | 'particle-convergence' | 'random';
type Variant = 'fullpage' | 'overlay';

export default function LoaderDemoPage() {
  const [active, setActive] = useState<{ anim: Anim; variant: Variant } | null>(null);

  const animations: Anim[] = ['orbiting-rings', 'hex-grid', 'scan-reveal', 'particle-convergence', 'random'];
  const variants: Variant[] = ['fullpage', 'overlay'];

  return (
    <div style={{ padding: '2rem', maxWidth: 800, margin: '0 auto' }}>
      <h1 style={{ marginBottom: '1.5rem', fontFamily: 'var(--font-heading)', color: 'var(--color-text-primary)' }}>
        CoreX Loader Demo
      </h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
        {variants.map((v) =>
          animations.map((a) => (
            <button
              key={`${v}-${a}`}
              onClick={() => setActive({ anim: a, variant: v })}
              style={{
                padding: '14px 20px',
                background: 'var(--color-bg-secondary)',
                border: '1px solid var(--color-border-subtle)',
                borderRadius: 'var(--radius-md)',
                color: 'var(--color-text-primary)',
                cursor: 'pointer',
                fontFamily: 'var(--font-body)',
                fontSize: '0.85rem',
                textAlign: 'left',
              }}
            >
              <strong>{v}</strong> — {a}
            </button>
          ))
        )}
      </div>

      <p style={{ marginTop: '1rem', color: 'var(--color-text-muted)', fontSize: '0.8rem' }}>
        Click anywhere on the loader to dismiss it.
      </p>

      {active && (
        <div onClick={() => setActive(null)}>
          <CoreXLoader
            variant={active.variant}
            animation={active.anim === 'random' ? undefined : active.anim}
          />
        </div>
      )}
    </div>
  );
}
